import React from 'react';
import { Switch } from '@/ui/switch';

interface GeneralSettingsProps {
  reviewEnabled: boolean;
  setReviewEnabled: (enabled: boolean) => void;
  autoReviewEnabled: boolean;
  setAutoReviewEnabled: (enabled: boolean) => void;
  includeSummary: boolean;
  setIncludeSummary: (enabled: boolean) => void;
}

export const GeneralSettings: React.FC<GeneralSettingsProps> = ({
  reviewEnabled,
  setReviewEnabled,
  autoReviewEnabled,
  setAutoReviewEnabled,
  includeSummary,
  setIncludeSummary,
}) => {
  return (
    <div className="space-y-8 max-w-3xl">
      <div className="flex items-center gap-2 mb-6">
        <span className="w-2 h-2 bg-neutral-500 rounded-none inline-block"></span>
        <h3 className="font-mono text-sm font-bold uppercase text-muted-foreground">General Configuration</h3>
      </div>

      {/* Enable Reviews */}
      <div className="border border-neutral-200 dark:border-neutral-800 p-6 bg-background">
        <div className="flex items-center justify-between">
          <div>
            <h4 className="font-mono font-bold uppercase text-sm mb-1">Enable Codii Reviews</h4>
            <p className="font-mono text-xs text-muted-foreground max-w-md">
              When disabled, Codii will not perform code reviews on new pull requests.
            </p>
          </div>
          <Switch
            id="review-enabled"
            checked={reviewEnabled}
            onCheckedChange={setReviewEnabled}
            className="data-[state=checked]:bg-green-600 dark:data-[state=checked]:bg-green-500 border-neutral-950 dark:border-neutral-100"
          />
        </div>
      </div>

      {/* Auto Review */}
      <div className="border border-neutral-200 dark:border-neutral-800 p-6 bg-background">
        <div className="flex items-center justify-between">
          <div>
            <h4 className="font-mono font-bold uppercase text-sm mb-1">Auto-review Pull Requests</h4>
            <p className="font-mono text-xs text-muted-foreground max-w-md">
              Automatically review all new pull requests without manual trigger.
            </p>
          </div>
          <Switch
            id="auto-review"
            checked={autoReviewEnabled}
            onCheckedChange={setAutoReviewEnabled}
            className="data-[state=checked]:bg-green-600 dark:data-[state=checked]:bg-green-500 border-neutral-950 dark:border-neutral-100"
          />
        </div>
      </div>

      {/* Include Summary */}
      <div className="border border-neutral-200 dark:border-neutral-800 p-6 bg-background">
        <div className="flex items-center justify-between">
          <div>
            <h4 className="font-mono font-bold uppercase text-sm mb-1">Include Summary</h4>
            <p className="font-mono text-xs text-muted-foreground max-w-md">
              Append a high-level summary of changes to the review comment.
            </p>
          </div>
          <Switch
            id="include-summary"
            checked={includeSummary}
            onCheckedChange={setIncludeSummary}
            className="data-[state=checked]:bg-green-600 dark:data-[state=checked]:bg-green-500 border-neutral-950 dark:border-neutral-100"
          />
        </div>
      </div>
    </div>
  );
};
